import React from 'react';
import NewHome from './NewHome';

export default function Home() {
  return <NewHome />;
}
